import React from 'react'
import classNames from 'classnames'
import styles from './StatusCaption.module.css'

export function StatusCaption ({ variant = 'light', children }) {
  return (
    <div className={classNames(styles.caption, styles[`caption${variant}`])}>
      {children}
    </div>
  )
}
